import classNames from 'classnames';
import { any, node, number, string } from 'prop-types';
import React from 'react';
import * as Render from '../Base/Render';
import FormatDateTime from '../FormatDateTime';
import { LazyLoadImage } from '../Image';

const SplitColumns = ({ children, split, className }) => {
  if (!split) return children;

  return <div className={className}>{children}</div>;
};

const ArticleList = (props) => {
  const getColumnClasses = (numOfItems, blockName) => {
    if (blockName === 'DoubleColumnBlock') {
      return 'column';
    }

    return classNames({
      columns: true,
      'medium-8': numOfItems === 1,
      'medium-4': numOfItems === 3 || numOfItems === 2,
      'medium-6 large-3': numOfItems > 3,
    });
  };

  const columnClasses = getColumnClasses(
    props.numOfItems,
    props.blockName ? props.blockName : props.pageName
  );

  const teaserTheme = classNames({
    'c-article-list__theme--default': !props.Theme,
    [`c-article-list__theme--${props.Theme}`]: props.Theme,
  });

  const headerClasses = classNames({
    'c-article-list__heading': true,
    [teaserTheme]: props.Theme,
  });

  const infoType = `c-article-list__type--${props.InformationType}`;
  const teaserClasses = classNames({
    'c-article-list': true,
    'c-article-list--related': true,
    'c-article-list--no-text': !props.Preamble,
    'c-article-list--full-layout': props.numOfItems === 1,
    'c-article-list--nth1': props.numOfItems === 1,
    'c-article-list--nth2': props.numOfItems === 2,
    'c-article-list--nth3': props.numOfItems === 3,
    'c-article-list--gt1': props.numOfItems > 1,
    'c-article-list--gt2': props.numOfItems > 2,
    'c-article-list--gt3': props.numOfItems > 3,
    'c-article-list--double-column': props.blockName === 'DoubleColumnBlock',
    [`c-article-list--${props.Theme}`]: props.Theme,
    [teaserTheme]: props.Theme,
    [infoType]: props.InformationType,
  });

  const setPreset = () => {
    switch (props.numOfItems) {
      case 1:
      case 2:
        return '1200px';
      default:
        return '407px';
    }
  };

  //If only one then split into two columnClasses
  const rowSplit = classNames({
    row: props.numOfItems === 1,
    'u-flexwrap': props.numOfItems === 1,
    'c-article-list--center': props.numOfItems <= 2,
  });

  const splitColumns = classNames({
    'medium-6 columns': props.Media && props.numOfItems === 1,
    'medium-12 columns': !props.Media && props.numOfItems === 1,
  });

  const teaserContainsImage =
    props.Media &&
    props.Media[0] &&
    props.Media[0].ImageUrl &&
    props.Media[0].ImageUrl.length > 0;

  return (
    <div className={columnClasses}>
      {props.Title && (
        <div className={teaserClasses}>
          <SplitColumns
            {...props}
            split={props.numOfItems === 1}
            className={rowSplit}
          >
            {props.Media && (
              <SplitColumns
                {...props}
                split={props.numOfItems === 1}
                className={splitColumns}
              >
                <div className="c-article-list__img-container">
                  {props.ShowVideoPlayIcon && teaserContainsImage && (
                    <img
                      src={'/ClientResources/Icons/play-button-small-white.svg'}
                      alt={'Artikel innehåller video'}
                      title={'Artikel innehåller video'}
                      className="c-teaser-videoicon"
                      tabIndex={'-1'}
                    />
                  )}

                  <Render.Block
                    blocks={props.Media}
                    propertyName="TeaserMedia"
                    currentPageProps={props}
                  >
                    <LazyLoadImage
                      className="c-article-list__img"
                      isBackgroundImage={true}
                      DefaultPreset={{ name: 'preset_1000' }}
                      Alt={props.ImageDescription}
                      Sizes={{
                        sizes: `(min-width: 1025px) ${setPreset()}, (min-width: 640px) calc(100vw / 3), 100vw`,
                      }}
                    />
                  </Render.Block>
                </div>
              </SplitColumns>
            )}
            <SplitColumns
              {...props}
              split={props.numOfItems === 1}
              className={splitColumns}
            >
              <div className="c-article-list__content-wrapper">
                <div className="c-article-list__content">
                  {props.Vignette && (
                    <span className="c-article-list__vignette">
                      {props.Vignette}
                    </span>
                  )}
                  {props.Date && <FormatDateTime date={props.Date} />}
                  {props.use1177ProfessionDesign ? (
                    <h3 className={headerClasses}>
                      <i className="c-article-list__vardpersonal__icon-arrow-right-blue"></i>
                      <a
                        className="c-article-list__vardpersonal__link"
                        href={props.Url}
                      >
                        {props.Title}
                      </a>
                    </h3>
                  ) : (
                    <h3 className={headerClasses}>
                      <a
                        data-event-category={props.Url}
                        data-event-action={props.Title}
                        data-event-name="Artikel i lista"
                        className="c-article-list__link"
                        href={props.Url}
                      >
                        {props.Title}
                      </a>
                    </h3>
                  )}
                  {typeof props.Preamble === 'string' && (
                    <div className="c-article-list__text">
                      <p>{props.Preamble}</p>
                    </div>
                  )}
                </div>
              </div>
            </SplitColumns>
          </SplitColumns>
        </div>
      )}
    </div>
  );
};

ArticleList.propTypes = {
  Preamble: node,
  numOfItems: number,
  Vignette: node,
  Theme: string,
  Title: string,
  Url: string,
  Media: any,
};

export default ArticleList;
